export function getDistanceTransportAnalyticsProps(profile) {
  const {
    miles_away_displayed: milesAwayDisplayed,
    logistics_display_type: logisticsDisplayType
  } = profile.distance_analytics_props || {};

  return {
    distance_description: profile.distance_description,
    transport_types: profile.transport_types,
    miles_away_displayed: milesAwayDisplayed,
    logistics_display_type: logisticsDisplayType
  };
}
